import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useCommandsStore } from '@/stores/commandsStore'
import { comandosLocaisDaAjuda, juntarComandos } from './comandos-da-ajuda'

/** Aba Comandos: lê o catálogo do store (nunca uma lista fixa) e soma os locais. */
export function AjudaComandos() {
  const { t, i18n } = useTranslation()
  const commands = useCommandsStore((s) => s.commands)
  const status = useCommandsStore((s) => s.status)
  const fetchCommands = useCommandsStore((s) => s.fetchCommands)

  useEffect(() => {
    void fetchCommands(i18n.language)
  }, [fetchCommands, i18n.language])

  const lista = useMemo(() => juntarComandos(commands, comandosLocaisDaAjuda(t)), [commands, t])

  return (
    <div>
      <p className="axg-ajuda-texto">{t('guidedTour.ajuda.comandos.intro')}</p>
      {status === 'loading' || status === 'idle' ? (
        <p role="status" className="axg-ajuda-texto" data-testid="ajuda-comandos-carregando">
          {t('guidedTour.ajuda.comandos.carregando')}
        </p>
      ) : null}
      {status === 'error' ? (
        <p role="alert" className="axg-ajuda-texto" data-testid="ajuda-comandos-erro">
          {t('guidedTour.ajuda.comandos.erro')}
        </p>
      ) : null}
      <ul className="axg-ajuda-lista" data-testid="ajuda-comandos-lista">
        {lista.map((c) => (
          <li key={c.id} className="axg-ajuda-cartao" data-testid={`ajuda-comando-${c.id}`}>
            <code className="axg-ajuda-codigo">/{c.id}</code>
            <div>
              <p className="axg-ajuda-item-titulo">{c.label}</p>
              {c.description ? <p className="axg-ajuda-texto">{c.description}</p> : null}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
